var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-area",style:(_vm.styles),on:{"click":_vm.onNavigation}})
}
var staticRenderFns = []

export { render, staticRenderFns }